const tokenKeys = {
  all: ['token'] as const,
  refresh: () => [...tokenKeys.all, 'refresh'] as const,
  webview: () => [...tokenKeys.all, 'webivew'] as const,
};

export { tokenKeys };
